@if (headerLoading) {
  <hw-spinner class="px-3 py-1" [spinnerMessage]="'loading your application...'" [faColour]="'#0A3E65'"
  [boxColour]="'#0A3E65'" [boxPadding]="'5px 15px'"></hw-spinner>
}


@if (!headerLoading) {
  <header class="portal-header">
    <div class="ebs-navbar">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        @if (isTheLoginScreen) {
          <div class="navbar-brand" style="display: flex !important;" >
            <a [href]="studentDashboardUrl" class="logo" >
              <img src="assets/img/logo.png" alt="Edinburgh Business School">
            </a>
          </div>
        }
        @if (!isTheLoginScreen) {
          <div class="navbar-brand">
            <a [href]="studentDashboardUrl" class="logo" >
              <img src="assets/img/logo.png" alt="Edinburgh Business School">
            </a>
          </div>
        }
        <div class="navbar-menu">
          <div class="navbar-end">
            <hw-top-menu [avatar]="avatar" [displayMenu]="displayMenu" [onePortalDashboard]="studentDashboardUrl">
            </hw-top-menu>
          </div>
        </div>
      </nav>
    </div>
  </header>
}